import { Routes } from '@angular/router';
import { WelcomeComponent } from './welcome/welcome.component';
import { DashboardComponent } from './features/dashboard/components/dashboard/dashboard.component';
import { AuthGuard } from '../security/auth.guard';
import { ArchiveComponent } from './features/archive/components/archive/archive.component';
import { ProgramplanComponent } from './features/programplan/components/programplan/programplan.component';
import { StatisticsComponent } from './features/statistics/statistics.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: "welcome"
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    component: DashboardComponent,
    data: { permission: 'view-dashboard' }
  },
  {
    path: 'archive',
    canActivate: [AuthGuard],
    component: ArchiveComponent,
    data: { permission: 'view-archive' }
  },
  {
    path: 'programplan',
    canActivate: [AuthGuard],
    component: ProgramplanComponent,
    data: { permission: 'view-programplan' }
  },
  {
    path: 'statistics',
    canActivate: [AuthGuard],
    component: StatisticsComponent,
    data: { permission: 'view-statistics' }
  },
  {
    path: 'welcome',
    component: WelcomeComponent,
  },
  {
    // Ziel der AuthGuard-Umleitung bei fehlender Berechtigung.
    path: 'unauthorized',
    component: UnauthorizedComponent,
  },
  {
    path: '**',
    component: WelcomeComponent
  },
];
